import { PDFDocument } from "pdf-lib";

export const mergePDFs = async (files: File[]): Promise<Blob> => {
    const mergedPdf = await PDFDocument.create();

    for (const file of files) {
        const bytes = await file.arrayBuffer();

        const pdf = await PDFDocument.load(bytes);

        const copiedPages = await mergedPdf.copyPages(
            pdf,
            pdf.getPageIndices()
        );

        copiedPages.forEach((page) => mergedPdf.addPage(page));
    }

    const mergedBytes = await mergedPdf.save();

    return new Blob([mergedBytes], {
        type: "application/pdf",
    });
};